// CompanyForm Component

/* eslint indent: 0 */

import React, { Component } from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'

import Typo from '../../typography/typo/typo.jsx'
import Select from '../../../common/form/select/select.jsx'
import Input from '../../form/input/input.jsx'
import IconButton from '../../common/icon_button/icon_button.jsx'
import UploadAvatar from '../../form/upload_avatar/upload_avatar.jsx'
import IntlMessage from '../../common/intl/intl_message.jsx'
import usastates from '../../../lib/usastates.jsx'
import { getVatRateSelectOptionsFromArray } from '../../../lib/vat_rates_select_options.js'
import { getVatRatesForCountry } from '../../../../shared/util/vat'

class CompanyForm extends Component {
  constructor (props) {
    super(props)

    this.state = {
      dataDate: null,
      imageAvatar: null,
      imageAvatarUrl: null,
      imageDeleted: false
    }

    this.data = {
      company: _.cloneDeep(this.props.company),
      countries: [
        { label: 'common.form.countryNederlands', value: 'NL' },
        { label: 'common.form.countryGermany', value: 'DE' },
        { label: 'common.form.countryEnglish', value: 'UK' },
        { label: 'common.form.countryUnitedStates', value: 'US' }
      ],
      isCompanyUS: props.company && props.company.country === 'US'
    }

    this._references = {
      inputCompany: React.createRef(),
      inputEmail: React.createRef(),
      inputsubscriptionEmail: React.createRef(),
      inputWebsite: React.createRef()
    }
  }

  static get propTypes () {
    return {
      company: PropTypes.object,
      onSubmit: PropTypes.func,
      onError: PropTypes.func,
      onVatValidate: PropTypes.func,
      showPaymentPeriod: PropTypes.bool
    }
  }

  static get defaultProps () {
    return {
      company: {},
      onSubmit: null,
      onError: null,
      onVatValidate: null,
      showPaymentPeriod: true
    }
  }

  componentDidMount () {
    document.body.addEventListener('keydown', this._onKeyDown)
  }

  componentWillUnmount () {
    document.body.removeEventListener('keydown', this._onKeyDown)
  }

  _onKeyDown = ev => {
    if (ev.keyCode === 13) {
      this._onFormSubmit()
    }
  }

  render () {
    const company = this.data.company
    const isCompanyUS = this.data.isCompanyUS
    const imageUrl = this.state.imageAvatar
      ? this.state.imageAvatarUrl
      : this.state.imageDeleted
      ? ''
      : company.imageUrl
    const defaultCountry = 'NL'
    const defaultVatRates = getVatRatesForCountry(defaultCountry)
    const vatRates = getVatRatesForCountry(this.data.company.country) || defaultVatRates
    const vatRateSelectOptions = getVatRateSelectOptionsFromArray(vatRates)

    return (
      <div className='company-form'>
        <div className='colleft'>
          <Typo className='profile'>
            <h2>
              <IntlMessage ident='setting.companyProfile.contentTitle' />
            </h2>
            <p>
              <IntlMessage ident='setting.companyProfile.contentInfo' />
            </p>
          </Typo>
          <UploadAvatar
            image={imageUrl}
            className='companyprofile-upload'
            uploadSuccess={this._onUploadSuccess.bind(this)}
            uploadError={this._onUploadError.bind(this)}
            onDeleteClick={this._onUploadDelete.bind(this)}
            iconDelete='profile-upload-delete'
            iconUpload='profile-upload'
          />
        </div>
        <div className='colright'>
          <form
            className='companyform'
            method='post'
            noValidate
            action='#'
            onSubmit={this._onFormSubmit.bind(this)}
          >
            <div className='form-layout'>
              <div className='layoutcol'>
                <div className='formsection'>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='company'
                        maxLength={100}
                        label='setting.companyProfile.companyNamePlaceHolder'
                        value={company.company}
                        size={10}
                        ref={this._references.inputCompany}
                        validations={['required']}
                        onChange={this._onChangeInput.bind(this, 'company')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='street'
                        maxLength={100}
                        label='setting.companyProfile.addressPlaceHolder'
                        styleDotted
                        value={company.street}
                        size={10}
                        onChange={this._onChangeInput.bind(this, 'street')}
                      />
                    </div>
                  </div>
                  {isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Select
                          options={usastates}
                          name='state'
                          label='setting.companyProfile.statePlaceHolder'
                          className='form-dropdown'
                          onChange={this._onChangeInput.bind(this, 'state')}
                          value={company.state}
                        />
                      </div>
                    </div>
                  )}
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='city'
                        maxLength={100}
                        label='setting.companyProfile.cityPlaceHolder'
                        styleDotted
                        value={company.city}
                        size={10}
                        onChange={this._onChangeInput.bind(this, 'city')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='postcode'
                        maxLength={100}
                        label='setting.companyProfile.zipCodePlaceHolder'
                        styleDotted
                        value={company.postcode}
                        size={10}
                        onChange={this._onChangeInput.bind(this, 'postcode')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Select
                        options={this.data.countries}
                        label='setting.companyProfile.countryPlaceHolder'
                        className='form-dropdown'
                        value={company.country}
                        multilingualOptions
                        name='country'
                        disabled
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='phone'
                        maxLength={100}
                        label='setting.companyProfile.telephonePlaceHolder'
                        styleDotted
                        value={company.phone}
                        size={10}
                        validations={['intlphone']}
                        onChange={this._onChangeInput.bind(this, 'phone')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='website'
                        maxLength={100}
                        label='setting.companyProfile.websitePlaceHolder'
                        styleDotted
                        value={company.website}
                        size={10}
                        ref={this._references.inputWebsite}
                        validations={['website']}
                        onChange={this._onChangeInput.bind(this, 'website')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='email'
                        maxLength={100}
                        label='setting.companyProfile.companyEmailPlaceHolder'
                        value={company.email}
                        size={10}
                        ref={this._references.inputEmail}
                        validations={['email']}
                        onChange={this._onChangeInput.bind(this, 'email')}
                      />
                    </div>
                  </div>
                  <div className='formrow'>
                    <div className='formcol'>
                      <Input
                        type='text'
                        name='subscriptionEmail'
                        maxLength={100}
                        label='setting.companyProfile.companysubscriptionEmailPlaceHolder'
                        value={company.subscriptionEmail}
                        size={10}
                        ref={this._references.inputsubscriptionEmail}
                        validations={['email']}
                        onChange={this._onChangeInput.bind(
                          this,
                          'subscriptionEmail'
                        )}
                      />
                    </div>
                  </div>
                  {!isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol2 col-left'>
                        <Input
                          type='text'
                          name='ibanNo'
                          maxLength={100}
                          label='setting.companyProfile.ibanNumberPlaceHolder'
                          styleDotted
                          value={company.ibanNo}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'ibanNo')}
                        />
                      </div>
                      <div className='formcol2'>
                        <Input
                          type='text'
                          name='bicNo'
                          maxLength={100}
                          label='setting.companyProfile.bicNumberPlaceHolder'
                          styleDotted
                          value={company.bicNo}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'bicNo')}
                        />
                      </div>
                    </div>
                  )}
                  {!isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='bank'
                          maxLength={100}
                          label='setting.companyProfile.bankNamePlaceHolder'
                          styleDotted
                          value={company.bank}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'bank')}
                        />
                      </div>
                    </div>
                  )}
                  {isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='bankAccNo'
                          maxLength={100}
                          label='setting.companyProfile.bankAccNoPlaceHolder'
                          styleDotted
                          value={company.bankAccNo}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'bankAccNo')}
                        />
                      </div>
                    </div>
                  )}
                  {!isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='vatNo'
                          maxLength={100}
                          label='setting.companyProfile.vatNumberPlaceHolder'
                          styleDotted
                          value={company.vatNo}
                          size={10}
                          multilingual={false}
                          prefix={company.country}
                          onChange={this._onChangeInput.bind(this, 'vatNo')}
                          onBlur={this._onBlurVatNumber.bind(this)}
                        />
                      </div>
                    </div>
                  )}
                  {!isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='commerceNo'
                          maxLength={100}
                          label='setting.companyProfile.chambreOfCommerceNumberPlaceHolder'
                          value={company.commerceNo}
                          size={10}
                          styleDotted
                          onChange={this._onChangeInput.bind(
                            this,
                            'commerceNo'
                          )}
                        />
                      </div>
                    </div>
                  )}
                  {isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='swift'
                          maxLength={100}
                          label='setting.companyProfile.swiftPlaceHolder'
                          styleDotted
                          value={company.swift}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'swift')}
                        />
                      </div>
                    </div>
                  )}
                  {isCompanyUS && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='routingNo'
                          maxLength={100}
                          label='setting.companyProfile.routingNoPlaceHolder'
                          styleDotted
                          value={company.routingNo}
                          size={10}
                          onChange={this._onChangeInput.bind(this, 'routingNo')}
                        />
                      </div>
                    </div>
                  )}
                  {this.props.showPaymentPeriod && (
                    <div className='formrow'>
                      <div className='formcol'>
                        <Input
                          type='text'
                          name='payPeriod'
                          maxLength={100}
                          label='setting.companyProfile.defaultPaymetPeriodPlaceHolder'
                          value={company.payPeriod}
                          size={10}
                          styleDotted
                          onChange={this._onChangeInput.bind(this, 'payPeriod')}
                        />
                      </div>
                    </div>
                  )}
                  {!isCompanyUS && (
                    <div className='formrow'>
                      <Select
                        options={vatRateSelectOptions}
                        name='vatRate'
                        label='setting.companyProfile.defaultVatRateOptionsPlaceHolder'
                        className='form-dropdown'
                        onChange={this._onChangeInput.bind(this, 'vatRate')}
                        value={company.vatRate}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>

            <IconButton
              icon='common-success-tick'
              title='setting.companyProfile.tipSave'
              type='primary'
              size='big'
              canHover={false}
              className='wizard-submit'
              onClick={this._onFormSubmit.bind(this)}
            />
          </form>
        </div>
      </div>
    )
  }

  /* Event handlers */
  _onFormSubmit () {
    let noErrors = 0
    let field = ''
    if (
      this._references.inputCompany.current &&
      !this._references.inputCompany.current.validate()
    ) {
      noErrors++
      field = 'setting.companyProfile.msgCompanyNameError'
    } else if (
      this.data.company.email &&
      this._references.inputEmail.current &&
      !this._references.inputEmail.current.validate()
    ) {
      noErrors++
      field = 'setting.companyProfile.msgEmailError'
    } else if (!this.data.company.subscriptionEmail) {
      noErrors++
      field = 'setting.companyProfile.msgSubscriptionEmailError'
    } else if (
      this.data.company.subscriptionEmail &&
      this._references.inputsubscriptionEmail.current &&
      !this._references.inputsubscriptionEmail.current.validate()
    ) {
      noErrors++
      field = 'setting.companyProfile.msgSubscriptionValueEmailError'
    }

    if (this.data.company.website && this._references.inputWebsite.current) {
      if (!this._references.inputWebsite.current.validate()) {
        noErrors++
        field = 'setting.companyProfile.msgWebsiteError'
      } else {
        if (this._references.inputWebsite.current) {
          this.data.company.website = this._references.inputWebsite.current.getValueAsWebsite()
        }
      }
    } else if (this._references.inputWebsite.current) {
      this._references.inputWebsite.current.clearError()
    }

    if (noErrors === 0) {
      this.props.onSubmit(
        this.data.company,
        this.state.imageAvatar,
        this.state.imageDeleted,
        () => {
          this.setState({ imageAvatar: null })
        }
      )
    } else if (this.props.onError) {
      this.props.onError(field)
    }
  }

  _onChangeInput (name, value) {
    this.data.company[name] = value
    this.setState({ dataDate: new Date() })
  }

  _onUploadSuccess (file, message) {
    this.setState({ imageAvatar: message.id, imageAvatarUrl: message.url })
  }

  _onUploadError (_file, _message) {
    this.props.onError('common.form.uploadError')
  }

  _onUploadDelete () {
    if (this.state.imageAvatar) {
      this.setState({
        imageDeleted: true,
        imageAvatar: null,
        imageAvatarUrl: null
      })
    } else {
      this.setState({ imageDeleted: true, dataDate: new Date() })
    }
  }

  _onBlurVatNumber () {
    if (this.props.onVatValidate) {
    }
  }
}

export default CompanyForm
